import { DataGridComponent } from './data-grid.component';

export abstract class ExternalEditGridComponent<T> extends DataGridComponent{
  public isNew: boolean;
  public editItem: T;
  
  constructor(private ctor: { new(): T })
  {
    super();
  }

  public addHandler() 
  {
    this.editItem = new this.ctor();
    this.isNew = true;
  }

  public editHandler({dataItem})
  {
    this.editItem = dataItem;
    this.isNew = false;    
  }

  public cancelHandler() 
  {
    this.editItem = undefined;
  }

  public abstract saveHandler(item: T);

  public abstract removeHandler({ dataItem });
}